<template>
	<div>
		<figure class="zanwu" v-if="!list || list.length===0">
			<img src="@/assets/kong.png" alt="" srcset="" />
			<figcaption>暂无数据</figcaption>
		</figure>
		<div v-for="(i,idx) in list" :key="idx" class="imglist">
			<div class="imglist1" v-if="i.type=='image'">
				 <el-image 
				    style="	width:42px;
					height:42px;
					margin-right:10px;
					border-radius:6px;"
				    :src="i.file" 
				    :preview-src-list="[i.file]"
					:ref="'previewImg_' + idx">
				  </el-image>
				<div>
					<h3 v-if="lexing==0 || i.stage==1 ">{{idx+1}}承认图</h3>
					<h3 v-if="lexing==1 || i.stage==2 ">{{idx+1}}生产图</h3>
					<p>{{i.create_time}}</p>
				</div>
			</div>
			<div class="imglist1" v-else-if="i.type== 'pdf'" @click="downloadFile(i.file)">
				<img src="@/assets/img2.png" alt="" srcset="" />
				<div>
					<h3 v-if="lexing==0 || i.stage==1 ">{{idx+1}}承认图</h3>
					<h3 v-if="lexing==1 || i.stage==2 ">{{idx+1}}生产图</h3>
					<p>{{i.create_time}}</p>
				</div>
			</div>
			<div class="imglist1" v-else @click="downloadFile(i.file)">
				<img src="@/assets/img3.png" alt="" srcset="" />
				<div>
					<h3 v-if="lexing==0 || i.stage==1 ">{{idx+1}}承认图</h3>
					<h3 v-if="lexing==1 || i.stage==2 ">{{idx+1}}生产图</h3>
					<p>{{i.create_time}}</p>
				</div>
			</div>
			<span v-if="i.type=='image'" @click="previewImageBySpan($event)">查看</span>
			<span v-else-if="i.type=='pdf'" @click="downloadFile(i.file)">查看</span>
			<span v-else @click="downloadFile(i.file)">下载</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		props:{
			list:{
				type: Array,
				default: () => []
			},
			lexing:{}
		},
		methods: {
			downloadFile(url) {
				if (!url) return;
				const link = document.createElement("a");
				link.href = url;
				link.target = "_blank";
				link.download = "";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			previewImage(idx) {
				const refName = "previewImg_" + idx;
				const instance = this.$refs[refName];
				const instances = Array.isArray(instance) ? instance : [instance];
				this.$nextTick(() => {
					instances.forEach((vm) => {
						if (!vm) return;
						// 1) 优先尝试组件内部方法（部分 element-ui 版本可用）
						if (typeof vm.clickHandler === "function") {
							vm.clickHandler();
						}
						const root = vm.$el || vm;
						// Element UI 的 el-image 内部通常会把点击事件绑定在 inner img 上
						const target =
							(root.querySelector &&
								(root.querySelector(".el-image__inner") ||
									root.querySelector(".el-image__error") ||
									root.querySelector("img"))) ||
							root;
						if (target) {
							if (typeof target.click === "function") target.click();
							else {
								// 兜底：手动派发事件
								target.dispatchEvent(
									new MouseEvent("click", {
										bubbles: true,
										cancelable: true,
										view: window,
									})
								);
							}
						}
					});
				});
			}
			,
			// 点击“查看”时：从当前 span 所在的 imglist 容器里找到对应的 el-image 并触发 native click。
			// 这样不依赖 v-for 动态 ref 是否能精确拿到实例。
			previewImageBySpan(evt) {
				const spanEl = evt && evt.currentTarget;
				const imgListEl = spanEl && spanEl.parentElement; // 对应 v-for 外层 .imglist
				if (!imgListEl) return;
				this.$nextTick(() => {
					const target =
						imgListEl.querySelector &&
						(imgListEl.querySelector(".el-image__inner") ||
							imgListEl.querySelector(".el-image__error") ||
							imgListEl.querySelector("img")) ||
						null;
					if (target && typeof target.click === "function") target.click();
					else if (target) {
						target.dispatchEvent(
							new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
						);
					}
				});
			}
		}
	}
	
	
</script>

<style scoped>
	.imglist{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		background-color:#E9ECF4;
		border-radius: 8px 8px 8px 8px;
		margin-top:12px;
		padding:12px;
		box-sizing: border-box;
	}
	.imglist1 img{
		width:42px;
		height:42px;
		border-radius:6px;
		margin-right:10px;
	}
	.imglist1{
		display:flex;
		align-items: center;
	}
	.imglist1 h3{
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
	}
	.imglist1 p{
		font-size: 12px;
		color: rgba(30,58,138,0.6);
	}
	.imglist span{
		font-weight: 400;
		font-size: 14px;
		color: #4297FF;
		cursor:pointer;
	}
	.zanwu{
		width:100%;
		text-align: center;
		padding:40px 0px;
	}
	.zanwu figcaption{
		font-size:14px;
		color:#999;
	}
	.zanwu img{
		width:180px;
		height:180px;
	}
</style>